export default "__VITE_ASSET__QooMIc$y__"